import "@/App.css";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { LogoStrip } from "@/components/landing/LogoStrip";
import { CreatorIntro } from "@/components/landing/CreatorIntro";
import { Benefits } from "@/components/landing/Benefits";
import { WorkoutPreviews } from "@/components/landing/WorkoutPreviews";
import { AppFeatures } from "@/components/landing/AppFeatures";
import { Transformations } from "@/components/landing/Transformations";
import { Testimonials } from "@/components/landing/Testimonials";
import { Pricing } from "@/components/landing/Pricing";
import { FAQ } from "@/components/landing/FAQ";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";
import { StickyMobileCTA } from "@/components/landing/StickyMobileCTA";
import { ExitPopup } from "@/components/landing/ExitPopup";

function App() {
  return (
    <div className="font-sans antialiased">
      <Header />
      <main>
        <Hero />
        <LogoStrip />
        <Transformations />
        <CreatorIntro />
        <Benefits />
        <WorkoutPreviews />
        <AppFeatures />
        <Testimonials />
        <Pricing />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <StickyMobileCTA />
      <ExitPopup />
    </div>
  );
}

export default App;
